import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../redux/actions/A_user_actions';
import { Singleton } from '../../js/Singleton';
import { iconConfig, changePassIcon, agentInboundInfo, agentOutboundInfo, agentBothInfo, macHeader } from '../../Images/Images'
import { exitSVG } from '../../Images/SettingsSGV'
import { clockIcon } from '../../Images/GenericSVG'
import { SingletonSharedData } from '../../js/singletonSharedData';
import { INTEGRATION } from '../../constants'
import ConfigBar from './ConfigBar';
import CampaignType from './CampaignType.jsx';
import ChangePassBar from './ChangePassBar';
import AlertModalActions from '../../redux/actions/A_Alert_Modal';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { sendChangeDialingMode } from '../../redux/actions/A_messages_to_SM';
class SettingsBar extends Component {
  constructor(props) {
    super(props);
   
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
    this.iconAgentArray = { 1: agentOutboundInfo, 2: agentInboundInfo, 3: agentBothInfo };
    this.state = {
      configBarShowed: false,
      changePassBarShowed: this.props.showConfigPsw ? true :false,
      stateBar: 0,
      showConfigCampaignType: false,
      allowChangeDialingMode : this.sharedData.getDataPreviewPro().allowChangeDialMode,
      dialingMode: this.sharedData.getDataPreviewPro().dialingMode,
      firstSessionTime: (this.sharedData.getParameters().Hourlogin).substring(11,19)
    }
  }
  
  componentDidMount() {
    if (this.props.messagesIntegrations.dataMessageIntegration && this.props.messagesIntegrations.dataMessageIntegration.subaction === INTEGRATION.CHANGE_PASSWORD) {
      this.setState({ changePassBarShowed: true, stateBar: 1 });
    }
  }
  closingWindow = () => {
    this.setState({ stateBar: 2 });
    let _this = this;
    setTimeout(() => { _this.setState({ configBarShowed: false, changePassBarShowed: false, showConfigCampaignType: false}); }, 500);
  }
  closeWindow = () => {
    this.props.showAlertModal({
      type: "ModalAlert",
      title: "CenterWare Kolob",
      message: this.language.getText("alert-1601"),
      button: this.language.getText("CallControlcallCalificationyes"),
      secondButton: this.language.getText("CallControlcallCalificationno"),
      secondButtonFtn: () => { },
      buttonFun: () => { this.props.logout() }
    });
  }
  showOptionCampaignType = () => {
    this.setState({showConfigCampaignType:true});    
  }
  onClickShowSettingBar = () => {
    this.setState({ configBarShowed: true, stateBar: 1 });
  }

  onClickShowChangePassBar = () => {
    this.setState({ changePassBarShowed: true, stateBar: 1 });
  }
  onClickSendChangesCampType = (data) => {
    this.props.sendChangeDialingMode(data);
  }
  render() {
    const inactiveMode = this.sharedData.getIsInactiveState();
    return (
      <div className={`backgroundHeaderBars`}>
        <div className={"barsContainer" + (this.props.hideSettings  ? " hide" : "")}>
          <div className={"settingsBar " + (this.state.stateBar === 1 ? "moved" : (this.state.stateBar === 2 ? "normal" : ""))}>
            <img className="imageHeaderSelection" src={this.iconAgentArray[this.props.callType]} alt={"icon"}></img>
            <OverlayTrigger
              key="tlt-userName2"
              placement="bottom"
              overlay={
                <Tooltip className="notificationContainer-tooltip bottom show name2" id="tooltipId-tlt-userName2">{this.props.userName}</Tooltip>
              }
            >
            <p className="userNameSettings"><span>{this.props.userName}</span></p>
            </OverlayTrigger>
            <div className="containerSettingBar">
              <img className="imgMacSetting" src={macHeader} alt={"icon"}></img>
              <p className="txtMacSetting">{this.props.macAddres}</p>
            </div>
            <div className='containerfirstLoginTime'>
              <p className="firstLoginTime"> {this.language.getText("GUIConfigurationfirstLoginTime")}</p>
              <div className="containerSettingBarfirstLoginTime">
                <div className="imgTimeSettingFirst">{clockIcon}</div>
                <p className="sessionTimeSettingBarFirstTime">{this.state.firstSessionTime}</p>
              </div>
            </div>
            <p className="timeSettingBar">{this.language.getText("GUIConfigurationtagTimeOnline")}</p>
            <div className="containerSettingBar">
              <div className="imgTimeSetting">{clockIcon}</div>
              <p className="sessionTimeSettingBar">{this.props.timeSession}</p>
            </div>
            <div className="separatorBarSettings"></div>
            {!inactiveMode &&
              <div className="selectionSettingBar" onClick={this.onClickShowSettingBar}>
                <img className="imgSelectionOption" src={iconConfig} alt={"icon"}></img>
                <p className="txtSelectionOption">{this.language.getText("GUIConfigurationtitle")}</p>
              </div>
            }
            {!inactiveMode &&
              <div className="selectionSettingBar" onClick={this.onClickShowChangePassBar}>
                <img className="imgSelectionOption" src={changePassIcon} alt={"icon"}></img>
                <p className="txtSelectionOption">{this.language.getText("GUIPasswordChangetitle")}</p>
              </div>
            }
            <div className="selectionSettingBar exit" onClick={this.closeWindow}>
              <div className="imgSelectionOption">{exitSVG}</div>
              <p className="txtSelectionOption">{this.language.getText("GUIConfigurationsignOff")}</p>
            </div>
            {
              (this.state.allowChangeDialingMode && !inactiveMode) && 
              <div className="selectionSettingBar" onClick={this.showOptionCampaignType}>
                <img className="imgSelectionOption gcl-icon camps" ></img>
                <p className="txtSelectionOption">{this.language.getText("GUIPreviewcampaignType")}</p>
              </div>
            }
          </div>
          {this.state.configBarShowed &&
            <ConfigBar onClose={this.closingWindow} onChangeVisibility={(visible) => this.props.onChangeVisibility(visible)} />}
          {(this.state.changePassBarShowed )&&
            <ChangePassBar onClose={this.closingWindow} messagesIntegrations={this.props.messagesIntegrations} onCloseSettingBar={this.props.onClick}/>}
          {this.state.showConfigCampaignType &&
            <CampaignType 
              onClose={this.closingWindow} 
              onClickSendChangesCampType={this.onClickSendChangesCampType}
              />
          }
        </div>
        <div className={`backgroundHeaderBarsTransparent ${this.props.hideSettings ? "hideSettings" : ""}`} onClick={() => this.props.onClick()}></div>
      </div>
    )
  }
}
function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations,
    openConfig: state.setFlagShowAlert.showAlert
  }
}

function mapDispatchToProps(dispatch) {
  const { showAlertModal } = AlertModalActions.creators;
  return ({
    logout: () => { dispatch(logout()); },
    sendChangeDialingMode: (data) => {dispatch(sendChangeDialingMode(data)); },
    showAlertModal: (payload) => { dispatch(showAlertModal(payload)); },

  })
}
export default SettingsBar = connect(mapStateToProps, mapDispatchToProps)(SettingsBar);




// WEBPACK FOOTER //
// ./src/components/Header/SettingsBar.jsx